module.exports = __webpack_public_path__ + "static/media/portfolio1 (10).1112abe5.jpeg";